import { Injectable } from '@angular/core';
import { onCLS, onFCP, onLCP, Metric } from 'web-vitals';

@Injectable({
  providedIn: 'root'
})
export class PerformanceTrackingService {
  constructor() {
    this.trackWebVitals();
    this.trackPageLoadTime();
  }

  private sendToGTM(metric: Metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'web_vitals',
      web_vital_name: metric.name,
      web_vital_value: metric.value,
      web_vital_id: metric.id,
    });

    console.log('Web Vital sent to GTM:', metric.name, metric.value);
  }

  private trackWebVitals() {
    onCLS(this.sendToGTM);
    onFCP(this.sendToGTM);
    onLCP(this.sendToGTM);
  }

  private trackPageLoadTime() {
    window.addEventListener('load', () => {
      const loadTimeSec = (performance.now() / 1000).toFixed(2);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_load_time',
        load_time_sec: loadTimeSec,
      });

      console.log('Page Load Time sent to GTM:', loadTimeSec);
    });
  }
}
